import { navigate } from 'gatsby';

export const isLoggedIn = () => {
  if (process.env.GATSBY_LIV == 'livquest-calvi') {
    return !!localStorage.getItem('questCode');
  }
  return !!localStorage.getItem('accessToken') || !!process.env.GATSBY_LIV_API_TOKEN;
};

export const clearTokenAndRedirect = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  navigate('/');
};

export const processError = (error, msg) => {
  if (error.status === 401 || error.status === 403) {
    clearTokenAndRedirect();
  } else {
    throw new Error(`${msg} failed`);
  }
};

export const processResponse = (response) => {
  if (!response.ok) {
    const error = new Error('HTTP error');
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const getHeaders = () => {
  const token = localStorage.getItem('accessToken');
  if (token) return { Authorization: `Bearer ${token}` };
  return { Authorization: `Token ${process.env.GATSBY_LIV_API_TOKEN}` };
};
